/*
 * swipe aneluc sharjel reel-y ev
 * spini jamanak click aneluc kangnacnel spiny
 * wini jamanak click aneluc sksel nor spin
 * */
import { addToGameEvents, gameEvents } from '../../lib/gameEvents';
import { slotState } from '../../lib/slotStateBase';
import { generateTweenData, startTweenData } from '../../helpers/tween';
import { mousePositionToIconColumnRow } from '../../helpers/mousePositionToIconICoordinates';
import { iconStates as iconStages } from '../../core/pixi/icons';
import { gameMainDrawer } from '../../game/drawers/gameMainDrawer';
import { spinBarStore } from '../../store/spinBarStore';
import { isMobile } from '../../helpers/isMobile';
import { winBarStore } from '../../store/winBarStore';

let touchMoving,
  touchY,
  lastY,
  moveDistance,
  returnControl,
  pressedColumn,
  target,
  columns,
  returningToThePlace;

// const swipeStatusManager = new StatusControl(
//   setInteractive.bind(null, false),
//   setInteractive.bind(null, true)
// );

function stopReturn() {
  if (returnControl) {
    returnControl.stop();
    returnControl = null;
  }
}

function reset() {
  target.cursor = 'grab';
  pressedColumn = -1;
  touchMoving = false;
  moveDistance = 0;
}

function onTouchStart(event) {
  if (event.data.buttons !== 1 && returningToThePlace) return;
  if (returningToThePlace) {
    return;
  }
  const iconCoordinates = mousePositionToIconColumnRow(target, event);
  if (iconCoordinates) {
    if (slotState.spin || spinBarStore.isSpinStart || spinBarStore.isAutoBetStart) {
      stopReturn();
      spinBarStore.setIsDoubleClick(true);
      gameEvents.emit('stopSpin');
      reset();
      return;
    }
    // --------wini jamanak click anelu startspin----------
    if (winBarStore.winAmount && !spinBarStore.isSpinStart) {
      // stopReturn();
      gameEvents.emit('stopWin');
      gameEvents.emit('startSpin');
      // return;
    }
    if (
      (slotState.iconsState > iconStages.idle || slotState.iconsState === iconStages.idle) &&
      !spinBarStore.isSpinStart
    ) {
      stopReturn();
      pressedColumn = iconCoordinates.column;
      target.cursor = 'grabbing';
      moveDistance = 0;
      touchMoving = true;
      lastY = touchY = event.data.global.y;
    }
  }
}

function returnToThePlace(forceReturn, onComplete) {
  returningToThePlace = true;
  touchMoving = false;
  target.cursor = 'grab';
  function onF() {
    returningToThePlace = false;
    reset();
    if (onComplete) onComplete();
  }
  if ((!slotState.spin || forceReturn) && moveDistance !== 0) {
    const data = generateTweenData(moveDistance, 0, 100);

    returnControl = startTweenData(
      null,
      data,
      (t, v) => {
        if (pressedColumn === -1) {
          stopReturn();
          onF();
        } else {
          columns[pressedColumn].move(v - moveDistance);
          moveDistance = v;
        }
      },
      onF
    );
  } else onF();
}

function onPointerMove(event) {
  if (event.data.buttons !== 1 || pressedColumn === -1 || !touchMoving) return;
  const iconCoordinates = mousePositionToIconColumnRow(target, event);
  if (!iconCoordinates || iconCoordinates.column !== pressedColumn) {
    returnToThePlace();
  } else {
    moveDistance = (event.data.global.y - touchY) / target.worldTransform.d;
    const passedDistance = Math.abs(moveDistance);
    const spinDirection = moveDistance / passedDistance;

    columns[pressedColumn].move((event.data.global.y - lastY) / target.worldTransform.d);
    columns[pressedColumn]._direction = spinDirection;
    columns[pressedColumn].addIconIfNeed();
    lastY = event.data.global.y;
    const iconHeight = isMobile() ? 100 : 170;
    if (passedDistance >= iconHeight / 2) {
      gameEvents.emit('setSwipeDirection', spinDirection);
      gameEvents.emit('startSpin');
    }
  }
}

function setInteractive(interactive) {
  target.interactive = interactive;
  target.cursor = interactive ? 'grab' : 'default';
}

const events = {
  spinStarted() {
    moveDistance = 0;
    stopReturn();
    reset();
  },
};

export function addTouchControl(iconsContainer, reels) {
  columns = reels;
  touchMoving = false;
  touchY = 0;
  moveDistance = 0;
  returnControl = null;
  gameMainDrawer.slotBar.addOnDownHandler(onTouchStart);
  gameMainDrawer.slotBar.addOnUpHandler(returnToThePlace);
  gameMainDrawer.slotBar.addOnMoveHandler(onPointerMove);
  gameMainDrawer.slotBar.addOnOutHandler(returnToThePlace);
  target = iconsContainer;
  pressedColumn = -1;
  addToGameEvents(events);
  setInteractive(true);
}
